import React from 'react';
import classNames from 'classnames'

function ListTitle({ children, className, ...otherProps }) {
	return (
		<p {...otherProps}  className={classNames('fs-4 fw-400 c-neutral-700', className)}>
			{children}
		</p>
	);
}

export default ListTitle;
